import {
  DISCONNECT_STRIPE_ACCOUNT,
  DISCONNECT_STRIPE_ACCOUNT_FAILED,
  DISCONNECT_STRIPE_ACCOUNT_SUCCESS,
  GET_CONNECTED_ACCOUNTS_CONFIG,
  GET_CONNECTED_ACCOUNTS_CONFIG_FAILED,
  GET_CONNECTED_ACCOUNTS_CONFIG_SUCCESS,
  GET_CONNECTED_ACCOUNTS_LIST,
  GET_CONNECTED_ACCOUNTS_LIST_FAILED,
  GET_CONNECTED_ACCOUNTS_LIST_SUCCESS,
  GET_STRIPE_CONNECTED_ACCOUNT,
  GET_STRIPE_CONNECTED_ACCOUNT_FAILED,
  GET_STRIPE_CONNECTED_ACCOUNT_SUCCESS,
  HIDE_DISCONNECT_STRIPE_ACCOUNT_MODAL,
  OPEN_DISCONNECT_STRIPE_ACCOUNT_MODAL,
  RESET_CONNECTED_ACCOUNTS_CONFIG,
  RESET_CONNECTED_ACCOUNTS_LIST,
} from "./actionTypes"

const INITIAL_STATE = {
  loading: false,
  error: "",
  connectedAccountsConfig: null,
  connectedAccountsList: null,
  disconnectStripeAccountModalIsOpen: false,
  stripeConnectedAccount: null,
}

const Payouts = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_CONNECTED_ACCOUNTS_CONFIG:
    case GET_CONNECTED_ACCOUNTS_LIST:
    case DISCONNECT_STRIPE_ACCOUNT:
    case GET_STRIPE_CONNECTED_ACCOUNT:
      return {
        ...state,
        loading: true,
      }
    case GET_CONNECTED_ACCOUNTS_CONFIG_FAILED:
    case GET_CONNECTED_ACCOUNTS_LIST_FAILED:
    case DISCONNECT_STRIPE_ACCOUNT_FAILED:
    case GET_STRIPE_CONNECTED_ACCOUNT_FAILED:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }
    case GET_CONNECTED_ACCOUNTS_CONFIG_SUCCESS:
      return {
        ...state,
        connectedAccountsConfig: action.payload,
        loading: false,
      }
    case RESET_CONNECTED_ACCOUNTS_CONFIG:
      return {
        ...state,
        connectedAccountsConfig: null,
      }
    case GET_CONNECTED_ACCOUNTS_LIST_SUCCESS:
      return {
        ...state,
        connectedAccountsList: action.payload,
        loading: false,
      }
    case RESET_CONNECTED_ACCOUNTS_LIST:
      return {
        ...state,
        connectedAccountsList: null,
      }
    case OPEN_DISCONNECT_STRIPE_ACCOUNT_MODAL:
      return {
        ...state,
        disconnectStripeAccountModalIsOpen: true,
      }
    case HIDE_DISCONNECT_STRIPE_ACCOUNT_MODAL:
      return {
        ...state,
        disconnectStripeAccountModalIsOpen: false,
      }
    case DISCONNECT_STRIPE_ACCOUNT_SUCCESS:
      return {
        ...state,
        connectedAccountsList: state?.connectedAccountsList?.filter(
          acc => acc?.account_id !== action?.payload?.account_id
        ),
        loading: false,
      }
    case GET_STRIPE_CONNECTED_ACCOUNT_SUCCESS:
      return {
        ...state,
        stripeConnectedAccount: action.payload,
        loading: false,
      }
    default:
      return state
  }
}

export default Payouts
